let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bRKmQ")).then(() => parcelRequire('4BlC0'));